var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesAndFolders(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00838C",
    d: "M17.21 0H.782c-.43 0-.78.35-.78.78v21.906c0 .431.35.78.78.78H6.65v2.378c0 .242.113.47.305.618.192.148.442.198.676.136l1.366-.363 1.366.363c.066.017.134.026.2.026.17 0 .338-.056.476-.162.192-.147.304-.376.304-.618v-2.378h5.869c.43 0 .78-.349.78-.78V.78c0-.43-.35-.78-.78-.78zm-3.515 9.393H4.296c-.43 0-.78-.35-.78-.78 0-.431.35-.78.78-.78h9.4c.43 0 .78.349.78.78 0 .43-.35.78-.78.78zm.78 2.352c0 .431-.349.78-.78.78H4.296c-.43 0-.78-.349-.78-.78 0-.43.35-.78.78-.78h9.4c.43 0 .78.35.78.78zM3.518 5.48c0-.431.349-.78.78-.78h6.266c.43 0 .78.349.78.78 0 .43-.35.78-.78.78H4.295c-.43 0-.78-.35-.78-.78zm0 9.399c0-.431.349-.78.78-.78h9.398c.431 0 .78.349.78.78 0 .43-.349.78-.78.78H4.296c-.43 0-.78-.35-.78-.78zm5.479 8.612c-1.667 0-3.023-1.356-3.023-3.023s1.356-3.023 3.023-3.023 3.023 1.356 3.023 3.023-1.356 3.023-3.023 3.023z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.996,
    cy: 20.468,
    r: 1.463,
    fill: "#293461"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesAndFolders);
export default __webpack_public_path__ + "static/media/files-and-folders.7b1a3e10ff4c3c2561d24ec05022614f.svg";
export { ForwardRef as ReactComponent };